<template>
  <article class="garage-calendar-request">
    <div class="garage-calendar-request__wrapper">
      <h2 class="garage-calendar-request__header">
        <NuxtImg
          width="20px"
          height="20px"
          alt="Poproś o kalendarz"
          src="/_nuxt/no-calendar.svg"
        />
        Warsztat nie udostępnia kalendarza online
      </h2>

      <p class="garage-calendar-request__paragraph">
        Aktualnie warsztat nie udostępnia kalendarza i nie można się do niego umówić online. Poproś o udostępnienie
        wolnych terminów na stronie, aby móc zarezerwować wizytę.
      </p>

      <DmButton
        secondary
        class="w100"
        @click="emits('show-calendar-request-modal')"
        title="Poproś o kalendarz"
      />
    </div>
  </article>
</template>

<script setup lang="ts">
import { DmButton } from '@dobrymechanik/vue-ui-v2';

interface IEmits {
  (name: 'show-calendar-request-modal'): void;
}

// use
const emits = defineEmits<IEmits>()

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-calendar-request.scss');
</style>